<div class="pixie-modal" [@openClose]="isOpened ? 'open' : 'closed'">
<!-- [ngClass]="{'opened': isOpened, 'closed': !isOpened}" -->
  <div class="pixie-modal-wrapper">
    <div class="pixie-modal-content">
      <button
        (click)="closeModal($event)"
        class="pixie-button-mobile-close">
        <font-icon
          class="icon__previous"
          name="Previous"
          htmlentity="&#58125;"
          size="25"
          title="Previous"
        ></font-icon> 
      </button>
      <!-- Todo: take this section and create a child component -->
      <div class="pixie-modal-interstitial">
        <h3 class="title">{{title}}</h3>
        <div class="inner-container">
          <p class="description">{{description}}</p>
          <div class="actions">
            <a class="button cancel-button" name="&lid={{siteId}}__Close" (click)="closeModal($event)" [attr.aria-label]="'Dismiss dialog'">{{button.close}}</a>
            <a class="button continue-button" name="&lid={{siteId}}__Continue" href="{{link | absTrimmer}}" [attr.aria-label]="'Continue dialog'">{{button.continue}}</a>
          </div>
        </div>
      </div>
      <button
        (click)="closeModal($event)"
        class="pixie-button-close">
        <font-icon
          class="icon_close-reversed"
          name="Closed Reversed"
          htmlentity="&#58174;"
          size="24"
          title="Closed Reversed"
        ></font-icon> 
      </button>
    </div>
  </div>
</div>